import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Heading_root__Y4E8o{margin:1em 0;position:relative}.Heading_root__Y4E8o,.Heading_root__Y4E8o>a{color:var(--accent-color)!important}.Heading_root__Y4E8o .Heading_link__JTd0P{bottom:0;display:block;left:-1.7em;min-height:100%;opacity:0;padding:.8em 1em 0!important;pointer-events:all!important;position:absolute;right:1.7em;text-decoration:none;transition:all .2s ease-out}.Heading_root__Y4E8o:hover .Heading_link__JTd0P{opacity:1;transform:translateX(-5px)}";
var S = {"root":"Heading_root__Y4E8o","link":"Heading_link__JTd0P"};
styleInject(css_248z);

export { S as default };
